package pl.decks.personal.components.widgets.timeline

import androidx.compose.runtime.Composable

class MonthRenderer(
    val marker: @Composable (YearMonth) -> Unit,
    val label: @Composable (YearMonth) -> Unit,
) {
    companion object {
        val default = MonthRenderer(
            marker = { MonthMarkers.RoundedBar() },
            label = {},
        )
    }
}
